<!--
 * @Date: 2024-01-02 10:48:09
 * @Author: jm
 * @LastEditTime: 2024-01-18 11:33:38
 * @LastEditors: jm
 * @FilePath: \gameclub\src\components\SlidesPer.vue
 * @Description: 
-->
<template>
  <div class="swiper-container hot">
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="(item, i) in dataList"
        v-if="dataList.length > 0"
        @click="clickImg(item)"
      >
        <img :src="item.gamelogo" alt="" class="pic" />
        <p class="name">{{ item.gamename }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "@/styles/swiper.scss";
export default {
  data() {
    return {
    };
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    // 监听屏幕宽度和高度变化
  },
  methods: {
    init() {
      let _this = this;

      var swiper = new Swiper(".hot", {
        // direction: 'vertical', // 垂直切换选项
        loop: true, // 循环模式选项
        // 如果需要分页器
        slidesPerView: 2.5,
        slidesPerColumn: 2,
        spaceBetween: 1,
      });
    },
    clickImg(data) {
      this.$emit("onClick", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.swiper-container {
  width: 1000px;
  height: auto;
  margin: 40px auto 0px;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  height: 500px !important;
  line-height: 360px !important;
  margin-top: 0px !important;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  .pic {
    width: 360px;
    height: 360px;
    border-radius: 40px;
    box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.3);
  }
  .name {
    line-height: 150px;
    color: #ffffff;
    font-size: 40px;
    font-weight: bold;
    width: 360px;
    text-align: center;
    @include textoverflow(1);
  }
}
</style>
